/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsassistantcaption2Inputs */

const en_statsassistantcaption2 = /** @type {(inputs: Statsassistantcaption2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan assistant (7 days)`)
};

const de_statsassistantcaption2 = /** @type {(inputs: Statsassistantcaption2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan-Assistent (7 Tage)`)
};

/**
* | output |
* | --- |
* | "Plan assistant (7 days)" |
*
* @param {Statsassistantcaption2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsassistantcaption2 = /** @type {((inputs?: Statsassistantcaption2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsassistantcaption2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsassistantcaption2(inputs)
	return de_statsassistantcaption2(inputs)
});
export { statsassistantcaption2 as "statsAssistantCaption" }